import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'antd';
import Swal from 'sweetalert2';
import { useSimulationContext } from '../../../../contexts/SimulationContext';
import ApiService from '../../../../services/ApiService';
import { SIMULATION_COUNTRY_STATES } from '../../../../data';

export const Review = ({ onChangeStep }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { simulationCountry, fetchSimulationCountry } = useSimulationContext();
  const [isStarting, setIsStarting] = useState(false);

  const endedYear = Number(simulationCountry?.simulationCountryYear ?? 0);
  const nextYear = endedYear + 1;

  const handleStartNewYear = async () => {
    setIsStarting(true);
    try {
      const res = await ApiService.advanceSimulationCountry(params.simulationCountryId, {
        carbohydrateObjectListString: '',
        proteinObjectListString: '',
        waterObjectListString: '',
        specialObjectListString: '',
      });

      if (!res.success) {
        return;
      }

      const updatedYear = Number(res.result?.simulationCountryYear);
      const updatedState = Number(res.result?.simulationCountryState);
      const didAdvance =
        updatedYear === nextYear && updatedState === SIMULATION_COUNTRY_STATES.NEW_YEAR;

      if (!didAdvance) {
        await Swal.fire({
          title: 'Could not start the new year',
          text: 'Please refresh the page and try again. If this keeps happening, the app may still be connected to an older server that has not been updated yet.',
          icon: 'warning',
        });
        return;
      }

      await fetchSimulationCountry();

      await Swal.fire({
        title: `Year ${nextYear} is ready!`,
        text: 'Press Begin on the welcome screen to start playing your new year.',
        icon: 'info',
      });
      navigate(`/portal/simulations/${params.simulationCountryId}/welcome`);
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <div className="d-flex flex-column align-center">
      <h3>
        You have ended Year {endedYear} and are ready to start Year {nextYear}
      </h3>
      <p>Please review the national and world briefings before you begin.</p>
      <img src="/images/pages/simulation/feed/bookmark.png" alt="Bookmark" />
      <p>When you are ready, start your new year to replenish yearly uses and continue playing.</p>
      <div className="d-flex justify-center mt-16">
        <Button style={{ width: 200 }} onClick={() => onChangeStep(3)}>
          Back
        </Button>
        <Button
          style={{ width: 200 }}
          className="ml-16"
          type="primary"
          loading={isStarting}
          onClick={handleStartNewYear}
        >
          Start New Year
        </Button>
      </div>
    </div>
  );
};
